<template lang='pug' src='./treatment.pug'></template>

<script>
import Loader from 'components/loader/loader'
import ModalContact from 'components/modal/modal-contact/modal-contact'
import BlockTitle from 'components/block/block-title/block-title'
import CustomTreatmentInvisalign from 'components/custom/custom-treatment-invisalign/custom-treatment-invisalign'
import CustomTreatmentInvisalignTeen from 'components/custom/custom-treatment-invisalign-teen/custom-treatment-invisalign-teen'
import CustomTreatmentTabs from 'components/custom/custom-treatment-tabs/custom-treatment-tabs'
import DividerText from 'components/divider/divider-text/divider-text'
import CustomTreatmentAcceleratedTreatments from 'components/custom/custom-treatment-accelerated-treatments/custom-treatment-accelerated-treatments'
import CustomTreatmentItero from 'components/custom/custom-treatment-itero/custom-treatment-itero'

export default {
  name: 'treatment',
  computed: {
    props () {
      return this.$store.state.pages.treatment
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader,
    ModalContact,
    BlockTitle,
    CustomTreatmentInvisalign,
    CustomTreatmentInvisalignTeen,
    CustomTreatmentTabs,
    DividerText,
    CustomTreatmentAcceleratedTreatments,
    CustomTreatmentItero
  },
  mounted () {
    // this.$nextTick(this.scrollToAfterLoad())
    this.scrollToAfterLoad()
    console.log(this.$route.hash)
  },
  methods: {
    scrollToAfterLoad () {
      setTimeout(() => {
        if (this.$route.hash === '#accelerated-treatment') this.$scrollTo('#accelerated-treatment')
      }, 3000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// treatment.vue?1fd47a72